import {inject, Signal, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {finalize} from 'rxjs';

export function postResource<T>(url: string, params: Signal<T>) {
  const http = inject(HttpClient);

  const loading = signal(false);
  const error = signal<unknown>(null);
  const data = signal<T | null>(null);

  function execute(opts?: {
    onSuccess?: (value: T) => void;
    onError?: (err: any) => void;
  }) {
    loading.set(true);
    error.set(null);

    http.post<T>(url, params())
      .pipe(finalize(() => loading.set(false)))
      .subscribe({
        next: res => {
          data.set(res);
          opts?.onSuccess?.(res);
        },
        error: err => {
          error.set(err);
          opts?.onError?.(err);
        },
      });
  }

  return {
    loading,
    error,
    data,
    execute,
  };
}
